import { Component, Input, OnChanges } from '@angular/core';
import { LayoutDefs, LayoutType } from 'rev-shared/webrtc/Layouts';
import { scaleRect } from 'rev-shared/webrtc/LayoutUtil';
import styles from './ProducerSidebar.module.less';

@Component({
	selector: 'layout-icon',
	templateUrl: './LayoutIcon.Component.html',
	host: {
		'[class]': 'styles.layoutIconRoot'
	},
	standalone: false
})
export class LayoutIconComponent implements OnChanges {
	@Input() public layoutType: LayoutType;

	public readonly styles = styles;
	public isFullFrame: boolean;
	public tiles: any[];

	public ngOnChanges(): void {
		const xScale = 100/1920;
		const yScale = 100/1080;
		const format = x => `${x}%`;

		this.isFullFrame = this.layoutType === LayoutType.FullFrame;
		this.tiles = LayoutDefs[this.layoutType]?.map(r => {
			const rect = scaleRect(r, xScale, yScale);
			return {
				top: format(rect.y),
				left: format(rect.x),
				height: format(rect.h),
				width: format(rect.w)
			};
		});
	}
}
